import React from 'react';
import { Button } from 'antd';
import { SafetyCertificateOutlined } from '@ant-design/icons';
import PromptRail from './PromptRail';

export default function AskEmptyState({ onOpenScreener, questions, onSelectQuestion, loading }) {
  return (
    <div className="glp1-empty-state">
      <div className="glp1-empty-primary">
        <h2 className="glp1-empty-title">Ask a GLP-1 Bridge workflow question</h2>
        <p className="glp1-empty-copy">
          Get CMS-grounded answers on Part D routing, eligibility, prior authorization, pharmacy rejects,
          copay rules, and documentation.
        </p>
        <PromptRail
          questions={questions}
          onSelect={onSelectQuestion}
          loading={loading}
        />
        <Button
          type="default"
          icon={<SafetyCertificateOutlined />}
          onClick={onOpenScreener}
          className="glp1-empty-screener-action"
        >
          Start eligibility screener
        </Button>
      </div>
    </div>
  );
}
